import React from "react";

interface SkipLinkProps {
  /** The ID of the main content element to skip to */
  targetId?: string;
  /** Custom label for the skip link */
  label?: string;
}

/**
 * SkipLink component for keyboard/screen reader users to bypass navigation
 *
 * Best Practice: Place this as the first focusable element in your app.
 * It remains hidden until focused, then appears for keyboard users.
 */
const SkipLink: React.FC<SkipLinkProps> = ({
  targetId = "main-content",
  label = "Skip to main content",
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.setAttribute("tabindex", "-1");
      target.focus();
      target.removeAttribute("tabindex");
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition-all"
    >
      {label}
    </a>
  );
};

export default SkipLink;
